import { memo } from 'react';
import SearchAutocompleteTaskComponent from './SearchAutocompleteTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

function SearchAutocompleteViewComponent(props: StepViewComponentProps) {
  return <SearchAutocompleteTaskComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(SearchAutocompleteViewComponent);
